import { z } from 'zod';
/**
 * Le **type de bâtiment** du lieu contrôlé — `Site.building_type`
 * ([M10](../../../../docs/MODELE-DONNEES.md#m10)), la colonne « Type » du tableau des demandes de
 * GHP. Les six valeurs retenues par #586 : les cinq de la feuille « Divers » de GHP (21/10/2026),
 * plus « Industriel », vu dans le tableau des demandes. Les codes partagés avec le type de
 * résidence du relevé (`RESIDENCE_TYPE_LABELS`) y gardent le même sens.
 *
 * ⚠️ **Le type de bâti, rien d'autre** : « Professionnel » n'est pas une catégorie de client, et ce
 * n'est pas la production d'eaux usées de la fiche terrain (`Domestique / Professionnel /
 * Industriel`), qui qualifie l'effluent.
 */
export const BUILDING_TYPES = [
    'house',
    'professional',
    'industrial',
    'apartment_building',
    'apartment',
    'common_areas',
];
export const buildingTypeSchema = z.enum(BUILDING_TYPES);
export const BUILDING_TYPE_LABELS = {
    house: 'Maison',
    professional: 'Professionnel',
    industrial: 'Industriel',
    apartment_building: 'Immeuble',
    apartment: 'Appartement',
    common_areas: 'Parties communes',
};
//# sourceMappingURL=building-type.js.map